module.exports = __webpack_public_path__ + "static/img/flag-nl.932bb89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag-nl.svg
// module id = C76t
// module chunks = 103